// extracted by mini-css-extract-plugin
module.exports = {"rating":"Di-z","numberOfStars":"Ei-z","count":"Fi-z"};